import kingspan from "../../assets/kingspan_logo_white.svg";
import React from "react";
import insubotLogo from "@/assets/Insubot.svg";

export const Footer = () => {
    return (
        <div className={"container mx-auto flex h-full items-center justify-between px-2"}>
            <img src={kingspan} className={"h-auto w-[100px] py-2"} alt="Kingspan logo" />
            <img src={insubotLogo} className="h-16 w-auto" alt="Insubot logo" />
        </div>
    );
};
